import React from "react";
import AppRoutes from "./routes/AppRoutes";
import "./web.css";
import "./App.css";
import ToastNotification from "./components/core/ToastNotifications";
import Loader from "./components/core/Loader";
import WelcomeModal from "./components/core/WelcomeModal";
import { useSelector } from "react-redux";
import { userSelector } from "./redux/slices/userSlice";

function App() {
  const userData = useSelector(userSelector);
  const welcomeVideoStatus =
    userData?.welcomeVideo?.status === 1 ? true : false;
  return (
    <>
      {/* <Loader /> */}
      {welcomeVideoStatus && <WelcomeModal />}
      <AppRoutes />
      <ToastNotification />
    </>
  );
}

export default App;
